// 数据库，封装了各种接口的调用
import { data } from 'jquery'
import request from './request'
import useFormData from './request/plugins/useFormData'
// import setHeader from './request/plugins/setHeader'
// 更新用户资料
export function updateUserInfo (data) {
  return request('/uaa/api/renter/information', 'POST', data)
}
// 获取当前用户的商城用户信息
export function getCurrentUserMallUserInformation (mobile) {
  return request('/uaa/api/mall-user/by-mobile/' + mobile, 'GET')
}
// 获取登录验证码
export function getCode (data) {
  return request('/uaa/api/public/sendAuthorizeCode', 'GET', data)
}

// 绑定手机号码
export function bindMobile (data) {
  return request('uaa/api/bindPhoneNumber', 'POST', data)
}

// 基因实验室订单列表
export function getLabOrderList (data) {
  return request('/lab/api/gene/order/export', 'POST', data)
}
// 基因实验室订单列表（过滤掉有待办的订单）
export function excludeTask (data) {
  return request('/lab/api/gene/order/exclude-task', 'POST', data)
}

// 基因实验室订单详情
export function getLabOrder (id) {
  return request('/lab/api/gene/order/' + id)
}
// 基因实验室订单状态详情
export function getLabOrderStatusDetail (data) {
  return request('/lab/api/gene/order/status/detail/by-example', 'POST', data)
}

// 基因实验室订单（包括订单详情，订单状态详情，和订单小状态）
export function getLabOrderDetail (id) {
  return request(`/lab/api/order/details/${id}`, 'GET')
}

/**
 * 基因实验室订单状态更新
 * @param {*} data
 */
export function geneOrderStatusUpdate (data) {
  return request('/lab/api/workflow/order-batch-status-update', 'POST', data)
}
/**
 * 订单状态更新文件上传接口
 * @param {*} data
 */
export function uploadTempFile (data) {
  return useFormData(request)('/lab/api/workflow/upload-temp-file', 'multipleFILE', data)
}
/**
 * 获取基因实验室订单列表数据
 * @param {*} page
 * @param {*} size
 */
export function getGeneLabOrders (data) {
  data.pageable = { page: 0, size: 9999 }
  return request('/lab/api/gene/order/by-example', 'POST', data)
}
/**
 * 获取目标状态的所有订单
 * @param {*} data
 */
export function getGeneLabOrdersTargetStatus (data) {
  // let data ={}
  // data.example={batchNumber:batchNumber}
  data.pageable = { page: 0, size: 9999 }
  // data.targetStatus = targetStatus
  return request('/lab/api/gene/order/by-example/target-status', 'POST', data)
}
/**
 * 批量创建B端销售订单
 * @param {*} data
 */
export function batchCreateOrder (data) {
  return request('/lab/api/workflow/order/batch', 'multipleFILE', data)
}
/**
 * 订单处理列表
 * @param {*} data
 */
export function orderHandleList (data) {
  return request('/lab/api/future-order-action-tasks/by-example', 'POST', data)
}
/**
 * 基因实验室订单状态更新(核酸提取批量手动勾选专用接口)
 * @param {*} data
 */
export function geneOrderStatusUpdateNoFile (data) {
  return request('/lab/api/workflow/order-batch-status-update/without-attachment', 'POST', data)
}
/**
 * oss直传获取签名
 * @param {*} data
 */
export function ossUploadBigFile (data) {
  return request('/lab/api/data-transfer/raw-data-upload-policy', 'POST', data)
}
/**
 * oss直传获取签名
 * @param {*} data
 */
export function ossUploadBigFileAdult (data) {
  return request('/adultlab/api/data-transfer/raw-data-upload-policy', 'POST', data)
}
/**
 * 根据签名上传文件(即将废弃)
 * @param {*} data
 */
export function getSignature (url, data) {
  return request(url, 'multipleFILE', data)
}

/**
 * 根据签名上传文件(useFormData)
 * @param {*} data
 */
export function getOssSignature (url, data) {
  return useFormData(request)(url, 'multipleFILE', data)
}

/**
 * 订单数的统计接口返回异常订单数和代办数
 * oss直传获取签名
 * @param {*} data
 */
export function getSpecialOrderCount () {
  return request('/lab/api/order/count', 'GET')
}
// 新建/编辑/提交商品
export function createdGoodsDraft (data) {
  return request('/mall/api/goods/save', 'POST', data)
}
// 根据商品归属查询商品类型列表
export function getGoodsTypeList (data) {
  return request('/mall/api/goods-type/belong/' + data.belong, 'GET')
}
// 获取全部商品类型
export function getGoodsTypes () {
  return request('/mall/api/goods-type', 'GET')
}
// 商品列表
export function goodsList (data) {
  return request('/mall/api/goods', 'POST', data)
}
// 促销活动相关商品列表
export function salesGoodsList (data) {
  return request('/mallsales/api/goods', 'POST', data)
}
// 商品详情
export function goodsDetail (id) {
  return request('/mall/api/goods/' + id, 'GET')
}
// 促销活动商品详情
export function salesGoodsDetail (id) {
  return request('/mallsales/api/goods/' + id, 'GET')
}
// 删除商品
export function goodsDelete (id) {
  return request('/mall/api/goods/' + id, 'DELETE')
}
/**
 * 处理代办
 * @param {*} data
 */
export function pendingTasksSubmit (data) {
  return request('/lab/api/future-order-action-tasks/submit', 'POST', data)
}
// 商品推荐
export function goodsRecommend (id) {
  return request('/mall/api/goods/recommend/' + id, 'POST')
}
// 取消推荐
export function goodsRecommendCancel (id) {
  return request('/mall/api/goods/cancel-recommend/' + id, 'POST')
}
// 修改推荐值
export function updateRanking (data) {
  return request('/mall/api/goods/update-ranking', 'PUT', data)
}
// 商品审核通过
export function goodsPublish (data) {
  return request('/mall/api/goods/publish', 'POST', data)
}
// 商品提交审核
export function applyForApproval (id) {
  return request('/mall/api/goods/apply-for-approval/' + id, 'POST')
}
// 商品审核驳回
export function approvalReject (id) {
  return request('/mall/api/goods/approval-reject/' + id, 'POST')
}
// 获取分组列表
export function getGoodsGroup (data) {
  return request('/mall/api/goods-groups/by-example', 'POST', data)
}
// 商品下架
export function goodsOffShelves (id) {
  return request('/mall/api/goods/offShelves/' + id, 'POST')
}
// 新建商品分组
export function newGoodsGroup (data) {
  return request('/mall/api/goods-groups', 'POST', data)
}
// 新建积分商品分组
export function newIntegralGoodsGroup (data) {
  return request('/points/api/goods-groups', 'POST', data)
}
// 获取商品分组详情
export function goodsGroupDetail (id) {
  return request('/mall/api/goods-groups/' + id, 'GET')
}
// 获取积分商品分组详情
export function integralGoodsGroupDetail (id) {
  return request('/points/api/goods-groups/' + id, 'GET')
}
// 编辑商品分组
export function groupEdit (data) {
  return request('/mall/api/goods-groups', 'PUT', data)
}
// 编辑积分商品分组
export function integralGroupEdit (data) {
  return request('/points/api/goods-groups', 'PUT', data)
}
// 删除商品分组
export function groupDelete (id) {
  return request('/mall/api/goods-groups/' + id, 'DELETE')
}
// 删除积分商品分组
export function integralGroupDelete (id) {
  return request('/points/api/goods-groups/' + id, 'DELETE')
}
// 基因实验室检测平台列表
export function labTestPlatformList (data) {
  return request('/lab/api/gene/product/by-organization-role', 'POST', data)
}
// 基因实验室检测平台--新建
export function labTestPlatformAdd (form) {
  return request('/lab/api/gene/product/save', 'POST', form)
}
/**
 * 基因检测平台 - 获取详情
 * @param {*} id
 */
export function getLabTestPlatform (id) {
  return request('/lab/api/gene/product/' + id)
}
/**
 * 检测列表-根据类型进行筛选/搜索检测项
 * @param {*} id
 */
export function getDetectionListByFilter (data) {
  return request('/gene/api/detection-item-entities/query', 'GET', data)
}
/**
 * 新建--检测项
 * @param {*} form
 */
export function detectionAdd (form) {
  return request('/gene/api/detection-item-entities', 'POST', form)
}
/**
 * 获取检测项
 *
 */
export function getDetection (id) {
  return request('/gene/api/detection-item-entities/' + id)
}
/**
 * 检测项 - 更新
 * @param {*} id
 * @param {*} form
 */
export function updateDetection (form) {
  return request('/gene/api/detection-item-entities', 'PUT', form)
}
/**
 * 删除检测项
 *
 */
export function deleteDetection (id) {
  return request('/gene/api/detection-item-entities/' + id, 'DELETE')
}

/**
 * 获取检测项语料列表数据
 * @param {*} page
 * @param {*} size
 */
export function getDetectionCorpusList (data) {
  return request('/gene/api/detection-item-corpus-entities/query', 'GET', data)
}
/**
 * 获取检测项语料
 *
 */
export function getDetectionCorpus (id) {
  return request('/gene/api/detection-item-corpus-entities/' + id)
}
/**
 * 新建--检测项语料
 * @param {*} form
 */
export function detectionCorpusAdd (form) {
  return request('/gene/api/detection-item-corpus-entities', 'POST', form)
}
// 获取当前的主要组织
export function getPrimaryOrganization () {
  return request('/uaa/api/organizations/primary', 'GET')
}
// 创建检测方法
export function methodAdd (data) {
  return request('/lab/api/gene/manager/method', 'POST', data)
}
// 修改检测方法
export function methodUpdate (data) {
  return request('/lab/api/gene/manager/method', 'PUT', data)
}
/**
 * 删除检测项
 *
 */
export function methodDelete (id) {
  return request('/lab/api/gene/manager/method/?method_id=' + id, 'DELETE')
}
// 检测平台更新
export function updateLabProduct (form) {
  // form.product_id = id
  return request('/lab/api/gene/product', 'PUT', form)
}
// 检测平台删除
export function deleteLabProduct (id) {
  return request('/lab/api/gene/product/' + id, 'DELETE')
}
export function getDetectionPackageEntities (data) {
  return request('/gene/api/detection-package-entities', 'GET', data)
}
/**
 * 根据检测项id查询检测项语料
 * @param {*} data
 */
export function getDetectionCorpusByid (id) {
  return request('/gene/api/detection-item-corpus-entities/find-detectionItemId/' + id, 'POST')
}
/**
 * 获取检测项配置
 *
 */
export function getDetectionConfig (id) {
  return request('/gene/api/detection-item-config-entities/by-detection-item/' + id)
}
/**
 * 获取基因套餐列表
 *
 */
export function getDetectionPackageList (data) {
  return request('/gene/api/detection-package-entities/query', 'GET', data)
}
// 根据查询条件获取套餐列表
export function getPackageList (data) {
  return request('/gene/api/detection-package-entities/by-example', 'POST', data)
}
/**
 * 删除套餐
 *
 */
export function deleteDetectionPackage (id) {
  return request('/gene/api/detection-package-entities/' + id, 'DELETE')
}
/**
 * 导入检测项配置参数
 * @param {*} form
 */
export function importConfigParams (form) {
  return request('/gene/api/importing/config-params', 'multipleFILE', form)
}
/**
 * 获取套餐全部数据
 *
 */
export function getDetectionPackage (id) {
  return request('/gene/api/detection-package-entities/full/' + id, 'GET')
}
/**
 * 新建--套餐
 * @param {*} form
 */
export function detectionPackageAdd (form) {
  return request('/gene/api/detection-package-entities', 'POST', form)
}
// 获取商城订单列表
export function getMallOrders (data) {
  return request('/mallsales/api/mall-orders/by-example', 'POST', data)
}
// 获取商城列表接口（按条件查询）
export function getMallOrderOfAll (data) {
  return request('/mallsales/api/mall-orders/page-query-for-all-orders', 'POST', data)
}
// 获取商品订单详情
export function goodsOrderDetail (id) {
  return request('/mallsales/api/mall-orders/admin/' + id, 'GET')
}
// 根据订单id获取发票列表
export function getOrderInvoice (id) {
  return request('/mallsales/api/mall-orders/invoice/' + id, 'GET')
}
// 下载发票
export function downloadInvoice (id) {
  return request('/mallsales/api/invoice/' + id, 'GET')
}
// 获取指定收货地址
export function shippingAddress (id) {
  return request('/mallsales/api/shipping-addresses/' + id, 'GET')
}
// 创建发货信息
export function creatDeliverGoodsDetail (data) {
  return request('/mallsales/api/mall-orders/ship', 'POST', data)
}
// 退款审批通过
export function approvalRefundment (data) {
  return request('/mallsales/api/mall-orders/approval-refundment', 'POST', data)
}
/**
 * 检测项语料 - 更新
 * @param {*} id
 * @param {*} form
 */
export function updateDetectionCorpus (form) {
  return request('/gene/api/detection-item-corpus-entities', 'PUT', form)
}
// 运营管理员申请退款
export function applyForRefundment (data) {
  return request('/mallsales/api/mall-orders/apply-for-refundment', 'POST', data)
}
/**
 * 删除检测项语料
 *
 */
export function deleteDetectionCorpus (id) {
  return request('/gene/api/detection-item-corpus-entities/' + id, 'DELETE')
}
/**
 * 创建知识库结构
 *
 */
export function createCorpusStructure (data) {
  return request('/gene/api/corpus-structures', 'POST', data)
}
/**
 * 获取知识库结构列表
 *
 */
export function getCorpusStructureList (data) {
  return request('/gene/api/corpus-structures', 'GET', data)
}
/**
 * 更新知识库结构
 *
 */
export function updateCorpusStructure (data) {
  return request('/gene/api/corpus-structures', 'PUT', data)
}
/**
 * 删除知识库结构
 *
 */
export function deleteCorpusStructure (id) {
  return request('/gene/api/corpus-structures/' + id, 'DELETE')
}
/**
 * 创建标题图标
 *
 */
export function createCorpusHeaderImages (data) {
  return request('/gene/api/corpus-header-images', 'POST', data)
}
/**
 * 删除知识库结构
 *
 */
export function getCorpusStructure (id) {
  return request('/gene/api/corpus-structures/' + id, 'GET')
}
/**
 * 搜索检测项
 *
 */
export function searchDetectionItem (key) {
  return request('/gene/api/detection-item-search?searchKey=' + key, 'GET')
}
/**
 * 获取知识库结构列表
 *
 */
export function getCorpusStructureListByType (data) {
  return request('/gene/api/corpus-structures/query-type', 'GET', data)
}
// 克根据姓名模糊查询
export function getCustomerSamples (data) {
  return request('/gene/api/customers/query', 'GET', data)
}
// 获取左侧菜单
export function getMenu () {
  return request('/uaa/api/user/menus', 'GET')
}
export function updateDetectionPackage (form) {
  return request('/gene/api/detection-package-entities', 'PUT', form)
}

/**
 * 获取报告
 * @param {*} form
 */
export function getReportData (data) {
  return request('/gene/api/report/data?jobId=' + data.jobId + '&strictCorpusCheck=true', 'POST', {})
}
/**
 * 删除检测项配置
 *
 */
export function deleteDetectionConfig (id) {
  return request('/gene/api/detection-item-config-entities/' + id, 'DELETE')
}
/**
 * 获取配置库列表
 *
 */
export function geConfigSuiteNames (params) {
  return request('/gene/api/config-suite-names', 'GET', params)
}
// /**
//  * 根据签名上传文件
//  * @param {*} data
//  */
// export function test (url, data) {
//   return useFormData(setHeader(request, { 'Content-Type': 'multipart/form-data' }))(url, 'POST', data)
//   // return useFormData(request)(url, 'multipleFILE', data)
// }
export function generalUpload (data) {
  return request('/messages/api/upload', 'multipleFILE', data)
}
// 退款订单分页查询
export function refundmentOrders (data) {
  return request('/mallsales/api/mall-orders/page-query-for-refundment-orders', 'POST', data)
}
// 销售订单详情，状态获取
export function getOrderProgress (id) {
  return request('/mallsales/api/mall-orders/get-order-progress/' + id, 'GET')
}
// 导出退款订单列表Excel
export function exportForRefundment (data) {
  //   return exportBinary('/mallsales/api/mall-orders/export-for-refundment-orders', 'POST', data)
  return request('/mallsales/api/mall-orders/export-for-refundment-orders', 'POST', data)
}
// 导出全部订单列表excel
export function exportAllOrder (data) {
  //   return exportBinary('/mallsales/api/mall-orders/export-for-all-orders', 'POST', data)
  return request('/mallsales/api/mall-orders/export-for-all-orders', 'POST', data)
}
// 带重采订单导出
export function exportResampleOrder (data) {
  return exportBinary('/mallsales/api/mall-orders/export-resample-waiting-for-processing', 'POST', data)
}
// 导出咨询工单
export function exportConsulting (data) {
  return exportBinary('/mallsales/api/consultings/download', 'POST', data)
}
// 下载并导出二进制文件
export function exportBinary (url, method, data) {
  return request(url, method, data, {
    headers: {
      'content-type': 'application/json;charset=UTF-8',
      filename: 'utf-8'
    },
    responseType: 'arraybuffer'
  })
}
/**
 * 删除检测项配置
 *
 */
export function getDetectionConfigParams (data) {
  return request(`/gene/api/detection-item-config-with-params-paged/${data.id}`, 'GET', data)
}
// 根据检测项id获取到对应的语料和配置
export function getDetectionWithCorpusAndConfig (id) {
  return request('/gene/api/detection-item-with-config-and-corpus/' + id, 'GET')
}
// 获取优惠劵列表
export function getCouponsList (data) {
  return request('/mallsales/api/discount-coupons/find-by-example', 'POST', data)
}
// 优惠劵提交审核(提交之后，状态变为“未审核”)
export function createCoupons (data) {
  return request('/mallsales/api/discount-coupons/create', 'POST', data)
}
// 保存优惠劵
export function saveCoupons (data) {
  return request('/mallsales/api/discount-coupons/save', 'POST', data)
}
// 获取优惠券详情
export function couponDetail (id) {
  return request('/mallsales/api/discount-coupons/with-goods-info/' + id, 'GET')
}
// 编辑优惠劵接口
export function couponEdit (data) {
  return request('/mallsales/api/discount-coupons/update', 'POST', data)
}
// 删除优惠劵
export function coupontDelete (id) {
  return request('/mallsales/api/discount-coupons/' + id, 'DELETE')
}
// 更改优惠劵状态
export function couponUpdateStatus (data) {
  return request('/mallsales/api/discount-coupons/update/status', 'POST', data)
}
// 下载/访问私有资源
export function downloadPrivateResource (data) {
  return request('/messages/api/private-resource/get-url', 'GET', data)
}
// 创建优惠劵活动
export function createPromotion (data) {
  return request('/mallsales/api/promotion-events/create/' + data.type, 'POST', data)
}
// 查询促销活动列表
export function getPromotionList (data) {
  return request('/mallsales/api/promotion-events/find-by-example', 'POST', data)
}
// 获取促销活动详情
export function promotionDetail (id) {
  return request('/mallsales/api/promotion-events/detail-info/' + id, 'POST')
}
// 删除促销活动
export function promotionDelete (id) {
  return request('/mallsales/api/promotion-events/' + id, 'DELETE')
}
// 更改促销活动状态
export function promotionStatus (data) {
  return request('/mallsales/api/promotion-events/update/status', 'POST', data)
}
// 编辑促销活动
export function promotionEdit (data) {
  return request('mallsales/api/promotion-events/update/' + data.type, 'POST', data)
}
// 管理员关闭订单
export function closeOrder (id) {
  return request('/mallsales/api/mall-orders/close-order/' + id, 'GET')
}
// 获取售后信息列表
export function afterSalesPolicies (data) {
  return request('/mall/api/after-sales-policies', 'GET', data)
}
// 获取售后政策详情
export function afterSalesPolicyDetail (id) {
  return request('/mall/api/after-sales-policies/' + id, 'GET')
}
// 删除售后政策
export function afterSalesDelete (id) {
  return request('/mall/api/after-sales-policies/' + id, 'DELETE')
}
// 获取运费规则列表
export function getCarriagePolicies (data) {
  return request('/mall/api/carriage-policies', 'GET', data)
}
// 获取运费规则详情
export function carriagePoliciesDetail (id) {
  return request('/mall/api/carriage-policies/' + id, 'GET')
}
// 新建运费规则
export function creatCarriagePolicies (data) {
  return request('/mall/api/carriage-policies', 'POST', data)
}
// 获取隐私条款列表
export function getPrivacyPolicies (data) {
  return request('/mall/api/privacy-policies', 'GET', data)
}
// 删除运费规则
export function carriagePolicyDelete (id) {
  return request('/mall/api/carriage-policies/' + id, 'DELETE')
}
// 新建隐私条款
export function createPrivacyPolicies (data) {
  return request('/mall/api/privacy-policies', 'POST', data)
}
// 获取隐私条款详情
export function privacyPolicyDetail (id) {
  return request('/mall/api/privacy-policies/' + id, 'GET')
}
export function privacyPolicyDelete (id) {
  return request('/mall/api/privacy-policies/' + id, 'DELETE')
}
// 根据基因检测套餐的平台查询检测周期
export function technologyCycle (type) {
  return request('/mallsales/api/lab/product/find-by-sequencing-technology/' + type, 'GET')
}
// 新建售后政策
export function creatAfterSalesPolicies (data) {
  return request('/mall/api/after-sales-policies', 'POST', data)
}
// 编辑售后政策
export function editAfterSalesPolicy (data) {
  return request('/mall/api/after-sales-policies', 'PUT', data)
}
// 商城用户查询
export function getMallUser (data) {
  return request('/uaa/api/mall-user/page-by-query', 'POST', data)
}
// 后台商品分组，商品列表排序接口
export function goodsSort (data) {
  return request('/mall/api/goods/advanced-query-for-list', 'POST', data)
}
// 后台商品分组，商品列表排序接口,带sales信息
export function salesGoodsSort (data) {
  return request('/mallsales/api/goods/advanced-query-for-list', 'POST', data)
}
// 广告位列表接口
export function getBannerList (data) {
  return request('/mall/api/promotion-banners', 'GET', data)
}
// 获取所有的广告位定义
export function bannersPositions (data) {
  return request('/mall/api/promotion-banners/positions', 'GET', data)
}
// 替换指定位置上的所有推荐
export function bannersReplace (data) {
  return request('/mall/api/promotion-banners/replace', 'POST', data)
}
// 根据条件查询推荐位列表
export function bannerByExample (data) {
  return request('/mall/api/promotion-banners/by-example', 'POST', data)
}
// 查询活动设置接口
export function getActiveSetList (data) {
  return request('/mall/api/promotion-banners/by-example-with-position', 'POST', data)
}
// 根据指定的商品唯一id（goodsRecordId），获取其广告位资源
export function bannerGoodsResources (data) {
  return request('/mall/api/promotion-banners/' + data.type + '/goods/' + data.id, 'GET')
}
// 根据指定的新闻id,获取其广告位资源
export function bannerNewsResouces (data) {
  return request('/mall/api/promotion-banners/' + data.type + '/news/' + data.id, 'GET')
}
// 活动设置，根据所选优惠活动，获取url信息
export function promotionBannerUrl (data) {
  return request('/mallsales/api/promotion-events/banner-url/' + data.promotionEventId, 'GET', data)
}
// 根据检测项名字进行查询，用于查重
export function getDetectionItemByName (name) {
  let data = { name: name }
  return request(`gene/api/detection-item-entities/find`, 'GET', data)
}
// 根据知识库名称和知识库名进行查询，用于查重
export function getDetectionCorpusBycorpusAndName (corpusName, name) {
  let data = { corpusName: corpusName, name: name }
  return request(`gene/api/detection-item-corpus-by-name-and-corpus-name`, 'GET', data)
}
// 根据知识库结构名称和类型进行查询，用于查重
export function getCorpusStructureByquery (name, type) {
  let data = { type: type, name: name }
  return request(`gene/api/corpus-structures/query-type-name`, 'GET', data)
}
// 分页查询新闻列表
export function getNewsList (data) {
  // return request('/mall/api/news/get-news-by-example', 'POST', data)
  return request('/mall/api/news/get-news-query', 'POST', data)
}
// 获取新闻分类
export function newCategories () {
  return request('/mall/api/news/categories', 'GET')
}
// 新建新闻
export function creatNews (data) {
  return request('/mall/api/news', 'POST', data)
}
// 新建并发布新闻
export function saveAndPublishNews (data) {
  return request('/mall/api/news/save-and-publish', 'POST', data)
}
// 发布新闻
export function publishNews (id) {
  return request('/mall/api/news/publish/' + id, 'POST')
}
// 新闻下架
export function disabledNews (id) {
  return request('/mall/api/news/disable/' + id, 'POST')
}
// 新闻详情
export function newsDetail (id) {
  return request('/mall/api/news/' + id, 'GET')
}
// 编辑新闻
export function editNews (data) {
  return request('/mall/api/news', 'PUT', data)
}
// 删除新闻
export function deleteNews (id) {
  return request('/mall/api/news/' + id, 'DELETE')
}
// 获取省市区列表
export function getDivision (data) {
  // 查询省级列表provinceGbCode传0，cityGbCode传0；
  // 查询市级列表provinceGbCode传父级，cityGbCode传0，
  // 查询区级列表provinceGbCode传父级，cityGbCode传父级，
  return request(
    '/messages/api/gbcode-admin-divisions/' +
    data.provinceGbCode +
    '/' +
    data.cityGbCode,
    'GET'
  )
}
// 获取指定公开资源文件的最终链接（不带重定向），可直接作为图片链接用于图片显示（download设置为false），或者在新窗口中打开作为文件下载（download设置为true）
export function getResuorceUrl (data) {
  return request('/messages/api/public/public-resource/get-url', 'GET', data)
}
// 文章分页查询
export function enumerationByExample (data) {
  return request('/mall/api/enumeration/' + data.type + '/by-example', 'POST', data)
}
// 新闻分类带数量统计的查询接口
export function categoriesWithNewsCount (data) {
  return request('/mall/api/news/categories-with-news-count', 'GET', data)
}
// 新建文章
export function createEnumeration (data) {
  return request('/mall/api/news/categories/create', 'POST', data)
}
// 获取新闻分类详情
export function enumerationDetial (id) {
  // return request('/mall/api/enumeration/by-id/' + id, 'GET')
  return request('/mall/api/news/categories/' + id, 'GET')
}
// 编辑新闻分类
export function editNewsCategories (data) {
  return request('/mall/api/news/categories/update', 'POST', data)
}
// 获取待重采订单
export function waitingForSampleRecollect (data) {
  return request('/mallsales/api/mall-orders/resample/get-waiting-for-processing', 'POST', data)
}
// 创建重采订单
export function creatSampleRecollect (data) {
  return request('/mallsales/api/internal-orders/resample-place', 'POST', data)
}
// 重采订单详情。通过样本条码号查询订单详情
export function sampleOrderDetail (sampleId) {
  return request('/mallsales/api/mall-samples/get-mall-order/' + sampleId, 'GET')
}
// 根据样本条码号查询重采价格
export function sampleRecollectPrice (sampleId) {
  return request('lab/api/future-order-action-tasks/order/by-sample-id/' + sampleId, 'GET')
}
// 根据样本条码号查询重采价格(成人实验室)
export function sampleRecollectPriceAdultlab (sampleId) {
  return request('adultlab/api/future-order-action-tasks/order/by-sample-id/' + sampleId, 'GET')
}
// 获取快递列表
export function getExpresses (data) {
  return request('/mallsales/api/express-companies', 'GET', data)
}
// 创建快递
export function createExporess (data) {
  return request('/mallsales/api/express-companies', 'POST', data)
}
// 新建标签
export function createLabels (data) {
  return request('/recommendation/api/tags', 'POST', data)
}
// 按条件获取标签列表
export function getLabelsList (data) {
  return request('/recommendation/api/tags-by-example', 'POST', data)
}
// 关联标签，选择标签时，根据名字的模糊查询
export function labelListByName (data) {
  return request('/recommendation/api/tags-by-name-like', 'POST', data)
}
// 编辑标签
export function editLabel (data) {
  return request('/recommendation/api/tags', 'PUT', data)
}
// 删除标签
export function deleteLabel (id) {
  return request('/recommendation/api/tags/' + id, 'delete')
}
// 获取标签关联
export function getRelatedLabels (data) {
  return request('/recommendation/api/related-tags', 'GET', data)
}
// 新建关联标签
export function createRelatedLabel (data) {
  return request('/recommendation/api/related-tags', 'POST', data)
}
// 更新关联标签列表
export function updateRelatedLabel (data) {
  return request('/recommendation/api/related-tags-list', 'POST', data)
}
// 删除关联标签
export function deleteRelatedLabel (id) {
  return request('/recommendation/api/related-tags/' + id, 'DELETE')
}
// 第三方供应商列表
export function getVendorsOrganizations (data) {
  data = data.pageable ? data : { pageable: data }
  return request('/mallsales/api/vendors/page', 'POST', data)
}
// 新建退款原因
export function newRefundmentReason (data) {
  return request('/mallsales/api/enumeration/' + data.type + '/add', 'POST', data)
}
// 获取退款原因
export function getRefundmentReason (data) {
  return request('/mallsales/api/enumeration/' + data.type + '/', 'GET')
}
// 退款驳回
export function rejectRefundment (data) {
  return request('/mallsales/api/mall-orders/reject-refundment', 'POST', data)
}
// 给商品新建标签，需要给商品标签打点
export function tagsObjects (data) {
  return request('/recommendation/api/tag-objects', 'POST', data)
}
// 保险理赔接口
export function insuranceClaimsLogin () {
  return request('/formerop/api/insurance/get-auth', 'GET')
}
// banner位置信息详情
export function promotionBannersPosition (data) {
  return request('/mall/api/promotion-banners/' + data.type + '/position/' + data.id)
}
// 分页查询商品分组（带商品总量信息）
export function groupWithGoodsCount (data) {
  return request('/mall/api/goods-groups/find-group-with-goods-count', 'POST', data)
}
// 分页查询积分商品分组（带商品总量信息）
export function integralGroupWithGoodsCount (data) {
  return request('/points/api/goods-groups/find-group-with-goods-count', 'POST', data)
}
// 第三方供应商列表
export function getVendorsList (data) {
  return request('/mallsales/api/vendors/page', 'POST', data)
}
// 设置商品未置顶
export function setStick (id) {
  return request('/mall/api/goods/stick/' + id, 'POST')
}
export function cancelStick (id) {
  return request('/mall/api/goods/cancel-stick/' + id, 'POST')
}
// 修改新闻推荐值
export function updateNewsRanking (data) {
  return request('/mall/api/news/ranking/' + data.id + '/' + data.ranking, 'POST')
}
// 设置新闻未置顶
export function setNewsStick (id) {
  return request('/mall/api/news/stick/' + id, 'POST')
}
export function cancelNewsStick (id) {
  return request('/mall/api/news/cancel-stick/' + id, 'POST')
}
// 新闻推荐
export function NewsRecommend (id) {
  return request('/mall/api/news/visible/' + id, 'POST')
}
// 取消推荐
export function NewsRecommendCancel (id) {
  return request('/mall/api/news/cancel-visible/' + id, 'POST')
}
// 获取预约工单列表
export function getOrderWorkList (data) {
  return request('/mallsales/api/consultings/by-example', 'POST', data)
}
// 获取预约工单详情
export function getOrderWorkDetail (id) {
  return request('/mallsales/api/consultings/' + id, 'GET')
}
// 预约工单修改
export function OrderWorkUpdate (data) {
  return request('/mallsales/api/consultings/update', 'POST', data)
}
// 获取预约工单导出历史列表
export function getOrderWorkHistoryList (data) {
  return request('/mallsales/api/consultings/history', 'GET', data)
}
// 获取预约工单导出历史列表
export function getCommodityDetail (id) {
  return request('/mallsales/api/public/goods/' + id, 'GET')
}
// 预约工单导出历史列表下载
export function HistoryListDownload (id) {
  return request('/mallsales/api/consultings/download-history/' + id, 'GET')
}
// 创建第三方供应商
export function createVendor (data) {
  return request('/mallsales/api/vendors/', 'POST', data)
}
// 修改第三方供应商
export function updateVendor (data) {
  return request('/mallsales/api/vendors/', 'PUT', data)
}
// 获取指定第三方供应商
export function getVendor (id) {
  return request(`/mallsales/api/vendors/${id}`, 'GET')
}
// 删除指定第三方供应商
export function deleteVendor (id) {
  return request(`/mallsales/api/vendors/${id}`, 'DELETE')
}
// 实验室订单模糊查询
export function labOrderFuzzy (data) {
  return request(`/lab/api/gene/order/fuzzy-query/`, 'POST', data)
}
// 获取指定商城用户信息
export function mallUserDetail (id) {
  return request('/uaa/api/mall-user/' + id, 'GET')
}
// 获取指定商城用户信息+收货地址
export function getUserDetailAddress (id) {
  return request('/uaa/api/mall-user/detail/' + id, 'GET')
}
// 获取第三方的职位列表
export function getPosition () {
  let data = {
    page: 0,
    size: 99999
  }
  return request(`/uaa/api/counselor/positions/`, 'GET', data)
}
// 创建第三方的职位
export function createPosition (data) {
  return request(`/uaa/api/counselor/positions/save`, 'POST', data)
}
// 获取第三方的职位列表
export function getCompany () {
  let data = {
    page: 0,
    size: 99999
  }
  return request(`/uaa/api/counselor/companies/`, 'GET', data)
}
// 创建第三方的职位
export function createCompany (data) {
  return request(`/uaa/api/counselor/companies/save`, 'POST', data)
}
export function getCounselorList (data) {
  return request(`/uaa/api/counselor-user-role-informations`, 'GET', data)
}
export function createCounselor (data) {
  return request(`/uaa/api/counselor-user-role-informations`, 'POST', data)
}
export function updateCounselor (data) {
  return request(`/uaa/api/counselor-user-role-informations`, 'PUT', data)
}
export function deleteCounselor (id) {
  return request(`/uaa/api/counselor-user-role-informations/${id}`, 'DELETE')
}
export function getCounselor (id) {
  return request(`/uaa/api/counselor-user-role-informations/${id}`, 'GET')
}
// 咨询师离职
export function counselorDeparture (id) {
  return request(`/uaa/api/counselor-departure/${id}`, 'GET')
}
// 导出第三方供应商
export function exportVendors (data) {
  return exportBinary(`/mallsales/api/vendors/export`, 'POST', data)
}
// CPS缴费
export function cpsPaymentList (data) {
  return request('/mallsales/api/mall/order/bill/find-all', 'POST', data)
}
// CPS缴费
export function counselorFind (data) {
  return request('uaa/api/counselor-user-role-informations/advanced-query', 'POST', data)
}
// CPS缴费列表的导出
export function exportCpsPaymentList (data) {
  //   return exportBinary('/mallsales/api/mall/order/bill/down-find-all', 'POST', data)
  return request('/mallsales/api/mall/order/bill/down-find-all', 'POST', data)
}
// 根据用户id获取健康档案
export function healthRecords (data) {
  return request('/uaa/api/health-records/by-type/' + data.type, 'POST', data.data)
}
// 根据用户id获取里程碑
export function lifeMilestone (data) {
  return request('/mallsales/api/life/milestone/query', 'POST', data)
}
// 根据用户id获取里程碑
export function getItemsByBaseId (data) {
  return request('/gene/api/package-detection-items/query', 'GET', data)
}
// 获取消息列表
export function getNoticeList (data) {
  return request('/messages/api/app-messages/page', 'POST', data)
}
// 获取意见反馈列表
export function getFeedbackList (data) {
  return request('/mall/api/feedbacks/search', 'POST', data)
}
// 获取意见反馈列表
export function getFeedbackDetail (id) {
  return request(`/mall/api/feedbacks/${id}`, 'GET')
}
// 搜索意见反馈列表
export function getFeedbackSearch (data) {
  return request(`/mall/api/feedbacks/name`, 'GET', data)
}
// 搜索咨询工单列表
export function getOrderWorkSearch (data) {
  return request(`/mallsales/api/consultings/key-like`, 'GET', data)
}
// 发布消息
export function publishNotice (data) {
  return request('/messages/api/app-messages', 'POST', data)
}
// 消息详情
export function noticeDetail (id) {
  return request('/messages/api/app-messages/' + id, 'GET')
}
// 知识库列表
export function getCorpusSuiteName (data) {
  return request('/gene/api/corpus-suite-names', 'GET', data)
}
// 获取健康档案详情
export function getHealthRecordDetail (id) {
  return request('/uaa/api/user/health-records/' + id, 'GET')
}
// 已邀请用户列表
export function pageInvitationUsers (data) {
  return request('/uaa/api/mall-user/page-invitation-users', 'POST', data)
}
// 获取城市列表
export function getAllCity () {
  return request('/messages/api/admin-divisions/city', 'GET')
}
// 获取所有商城用户
export function getAllMallUser () {
  return request('/uaa/api/mall-user/count', 'GET')
}
// 导出实验室订单
export function exportLabOrders (data) {
  return exportBinary(`lab/api/gene/order/export-excel`, 'POST', data)
}
/**
 * oss直传获取签名(除lab服务外)
 * @param {*} data
 */
export function ossUploadBigFileNotLab (data) {
  return request('messages/api/upload-policy', 'POST', data)
}
/**
 * 获取第三方代理商类型
 */
export function getVendorType () {
  return request('uaa/api/enum/vendor-types', 'GET')
}
/**
 * 修改密码
 */
export function changePassword (data) {
  return request('uaa/api/account/change-password', 'POST', data)
}
// 获取税务项目管理列表
export function getTaxProjctList (data) {
  return request('/pay/api/tax-project-manages', 'GET', data)
}
// 新建税务项目
export function creatTaxProject (data) {
  return request('/pay/api/tax-project-manages', 'POST', data)
}
// 获取税务项目详情
export function getTaxPrejectDetail (id) {
  return request('/pay/api/tax-project-manages/' + id, 'GET')
}
// 编辑税务项目
export function editTaxProject (data) {
  return request('/pay/api/tax-project-manages', 'PUT', data)
}
// 删除税务项目
export function deleteTaxProject (id) {
  return request('/pay/api/tax-project-manages/' + id, 'DELETE')
}
export function getOrganizations () {
  let data = {
    page: 0,
    size: 99999
  }
  return request('/uaa/api/organizations', 'GET', data)
}
// 修改实验室订单
export function editLabOrder (data) {
  return request('/lab/api/orders/edit', 'POST', data)
}
// 批量创建实验室订单
export function creatLabOrderFlow (data) {
  return request('/lab/api/workflow/order/import', 'POST', data)
}
// 根据代理获取产品
export function getProductByAgentId (data) {
  return request('/lab/api/agent-products/query', 'POST', data)
}
// 批量创建实验室订单
export function creatLabOrder (data) {
  return request('/lab/api/orders/by-agent', 'POST', data)
}
// 业务来源通用枚举
export function businessSource () {
  return request('/uaa/api/enum/business-sources', 'GET')
}
// 使用example对象为当前用户查询存储项列表
export function exportHistoryList (data) {
  return request('/mallsales/api/user/oss/items/by-example', 'POST', data)
}
// 使用example对象为当前用户查询存储项列表(实验室订单)
export function labExportHistoryList (data) {
  return request('/lab/api/user/oss/items/by-example', 'POST', data)
}
// 从导出历史列表中下载
export function exportHistoryDownload (id) {
  return request('/mallsales/api/user/oss/items/download/' + id, 'GET')
}
// 批量上传报告
export function uploadReport (data) {
  return request('/lab/api/workflow/upload-report', 'POST', data)
}
// 批量上传报告（成人）
export function AdultUploadReport (data) {
  return request('/lab/api/workflow/upload-report', 'POST', data)
}
// 批量下载报告
export function downloadReport (data) {
  return request('/lab/api/gene/order/export-pdf', 'POST', data)
}
// 报告审核上传真正的报告
export function uploadReports (data) {
  return request('/lab/api/orders/update-reports', 'POST', data)
}
// 获取代理商地区
export function getBusinessArea () {
  return request('/lab/api/enumeration/BUSINESS_ORIGIN_AREA', 'GET')
}
// 获取套餐的接口
export function getPackages () {
  return request('/lab/api/detection-package-entities', 'GET')
}
// 获取cps缴费记录分公司列表
export function findBranchCompany () {
  return request('/mallsales/api/mall/order/bill/find-branch-company', 'GET')
}
// 判断用户是否有筛选分公司的权限
export function isCompanyValide () {
  return request('/mallsales/api/mall/order/bill/branch/is-visible', 'GET')
}
// 系统用户列表
export function systemCustomerList (data) {
  return request('/uaa/api/organization-user-admin/roles', 'POST', data)
}
// 获取角色列表
export function rolesList (data) {
  return request('/uaa/api/roles', 'GET', data)
}
// 指定的组织创建用户
export function createdOrgCustomer (data) {
  return request('/uaa/api/organization-user-admin', 'POST', data)
}
// 老带新列表请求
export function customerBringNew (data) {
  return request('/mallsales/api/customer-bring-new/advanced-query', 'POST', data)
}
// 老带新详情
export function customerBringNewDetail (id) {
  return request('/mallsales/api/customer-bring-new/' + id, 'GET')
}
// 导出全部订单列表excel
export function exportOldToNew (data) {
  //   return exportBinary('/mallsales/api/mall-orders/export-for-all-orders', 'POST', data)
  return request('/mallsales/api/customer-bring-new/export', 'POST', data)
}
// 老带新奖励批量发放前各项统计
export function bringNewStatistice (ids) {
  return request('/mallsales/api/customer-bring-new/statistics', 'POST', ids)
}
// 老带新批量发放
export function bringNewReward (data) {
  return request('/mallsales/api/customer-bring-new/reward', 'POST', data)
}
// 被驳回的老带新记录修改
export function updateRewardAfterRejected (data) {
  return request('/mallsales/api/customer-bring-new/update-reward-after-rejected', 'POST', data)
}
// 老带新奖励审核列表
export function bringNewRewardList (data) {
  return request('/mallsales/api/bring-new-reward/advanced-query', 'POST', data)
}
// 老带新奖励审核列表+新老用户统计数据
export function bringNewRewardListStatistics (data) {
  return request('/mallsales/api/bring-new-reward/advanced-query/count-current-page', 'POST', data)
}
// 老带新奖励发放批量审核前各项统计(财务审核统计)
export function bringNewRewardStatistics (data) {
  return request('/mallsales/api/bring-new-reward/statistics', 'POST', data)
}
// 老带新奖励发放批量审核前各项统计(客服审核统计)
export function bringNewRewardStatisticsSaler (data) {
  return request('/mallsales/api/bring-new-reward/salesman-statistics', 'POST', data)
}
// 批量审核老带新奖励(通过)//财务审核
export function approvalByBatchBringNew (data) {
  return request('/mallsales/api/bring-new-reward/approve-for-batch', 'POST', data)
}
// 批量审核老带新奖励(驳回)//财务审核
export function rejectByBatchBringNew (data) {
  return request('/mallsales/api/bring-new-reward/reject-for-batch', 'POST', data)
}
// 批量审核老带新奖励(通过)//客服审核
export function approvalByBatchBringNewSaler (data) {
  return request('/mallsales/api/bring-new-reward/salesman-approve-for-batch', 'POST', data)
}
// 批量审核老带新奖励(驳回)//客服审核
export function rejectByBatchBringNewSaler (data) {
  return request('/mallsales/api/bring-new-reward/salesman-reject-for-batch', 'POST', data)
}
// 老带新奖励详情
export function BringNewAuditDetail (id) {
  return request('/mallsales/api/bring-new-reward/' + id, 'GET')
}
// 老带新奖励审核导出
export function BringNewAuditExport (data) {
  return request('/mallsales/api/bring-new-reward/export', 'POST', data)
}
// 老带新审核（老用户催费接口）
export function oldCudtomerRemindPay (ids) {
  return request('/mallsales/api/customer-bring-new/remind-pay', 'POST', ids)
}
// 获取系统用户详情
export function organizationUserInformation (data) {
  return request('/uaa/api/organization-user-admin/information', 'GET', data)
}
// 删除系统用户
export function deleteOrganizationUser (data) {
  return request('/uaa/api/organization-user-admin/roles?userLogin=' + data.userLogin, 'DELETE')
}
// 更新系统用户
export function updateOrganizationUser (data) {
  return request('/uaa/api/organization-user-admin/update', 'POST', data)
}
// 角色权限列表
export function rolesStatistics (data) {
  return request('/uaa/api/roles/statistics', 'GET', data)
}
// 获取权限列表
export function getPermissionsList (data) {
  return request('/uaa/api/permissions', 'GET', data)
}
// 新建角色
export function createdRoles (data) {
  return request('/uaa/api/roles', 'POST', data)
}
// 编辑角色
export function rolesDetail (name) {
  return request('/uaa/api/roles/' + name, 'GET')
}
// 删除角色
export function rolesDelete (id) {
  return request('/uaa/api/roles/' + id, 'DELETE')
}
// 编辑角色
export function rolesEdit (data) {
  return request('/uaa/api/roles', 'PUT', data)
}
// 查询提现列表
export function getWithdrawalsList (data) {
  return request('/mallsales/api/wallet-handler/withdrawals/advanced-query', 'POST', data)
}
// 提现详情
export function withdrawalDetail (id) {
  return request('/mallsales/api/wallet-handler/withdrawals/' + id, 'GET')
}
// 提现审核
export function withdrawalComplete (ids) {
  return request('/mallsales/api/wallet-handler/withdrawals/execute', 'POST', ids)
}
// 提现驳回
export function withdrawalReject (data) {
  return request('/mallsales/api/wallet-handler/withdrawals/reject', 'POST', data)
}
// 用户钱包详情查询
export function walletAccountDetail (id) {
  return request('/mallsales/api/wallet-handler/user-wallet/' + id, 'GET')
}
// 用户钱包账户手指明细
export function walletAccountRecord (data) {
  return request('/mallsales/api/wallet-handler/user-wallet/account-detail', 'POST', data)
}
// 编辑用户钱包
export function walletAccountEdit (data) {
  // return request('/mallsales/api/wallet-handler/bank-account', 'PUT', data)
  return request('/mallsales/api/wallet-handler/payee-account', 'PUT', data)
}
// 提现列表导出
export function withdrawalsExport (data) {
  return request('/mallsales/api/wallet-handler/withdrawals/export', 'POST', data)
}
// 成功邀请家系成员列表
export function familyListTable (data) {
  return request('/mallsales/api/family-relation/list', 'POST', data)
}
// 用户详情页面-已邀请用户（已邀请用户/已邀请家人数目统计）
export function inviteCustomerTotal (userLogin) {
  return request('/mallsales/api/customer-bring-new/total-of-relation/' + userLogin, 'GET')
}
// 已邀请用户-老带新用户
export function inviteCustomerBringNew (data) {
  return request('/mallsales/api/customer-bring-new/find-by-user-login', 'POST', data)
}
// 查询用户所有优惠劵
export function mallUserCoupons (data) {
  return request('/mallsales/api/mall-user-coupons/find-user-coupons', 'POST', data)
}
// 标记优惠劵为已使用
export function couponUsed (id) {
  return request('/mallsales/api/mall-user-coupons/coupon-used/' + id, 'GET')
}
// 查询商品二维码列表
export function getQrCodeList (data) {
  return request('/mallsales/api/commodity-qr-code/commodity-qr-codes', 'POST', data)
}
// 创建商品二维码
export function createQrCode (data) {
  return request('/mallsales/api/commodity-qr-code/commodity-qr-codes-vo', 'POST', data)
}
// 删除商品二维码
export function deleteQrCode (id) {
  return request('/mallsales/api/commodity-qr-code/commodity-qr-codes/' + id, 'DELETE')
}
// 下载商品二维码zip
export function downloadQrCode (id) {
  return request('/mallsales/api/commodity-qr-code/down-commodity-qr-codes/' + id, 'GET')
}
// 下载商品二维码图片
export function downloadQrCodeDetail (id) {
  return request('/mallsales/api/commodity-qr-code/down-commodity-qr-item-codes/' + id, 'GET')
}
// 预览二维码图片
export function reviewQrCode (id) {
  return request('/mallsales/api/commodity-qr-code/preview-commodity-qr-item-codes/' + id, 'GET')
}
// 商品详情列表
export function qrCodeDetailList (data) {
  return request('/mallsales/api/commodity-qr-code/commodity-qr-code-vm', 'POST', data)
}
// 手动发放奖励
export function grantRewad (data) {
  return request('/mallsales/api/manual-reward/create', 'POST', data)
}
// 手动发放奖励列表查询
export function customerGrantReward (data) {
  return request('/mallsales/api/manual-reward/advanced-query', 'POST', data)
}
// 手动发放奖励批量审核前统计(财务审核)
export function batchrewardStatistics (data) {
  return request('/mallsales/api/manual-reward/statistics', 'POST', data)
}
// 手动发放奖励批量审核前统计（客服审核）
export function batchrewardStatisticsSaler (data) {
  return request('/mallsales/api/manual-reward/salesman-statistics', 'POST', data)
}
// 手动发放奖励-批量审核//财务审核
export function batchManualRewardApprove (data) {
  return request('/mallsales/api/manual-reward/batch-approve', 'POST', data)
}
// 手动发放奖励-驳回//财务审核
export function batchManualRewardReject (data) {
  return request('/mallsales/api/manual-reward/batch-reject', 'POST', data)
}
// 手动发放奖励-批量审核//客服审核
export function batchManualRewardApproveSaler (data) {
  return request('/mallsales/api/manual-reward/salesman-batch-approve', 'POST', data)
}
// 手动发放奖励-驳回//客服审核
export function batchManualRewardRejectSaler (data) {
  return request('/mallsales/api/manual-reward/salesman-batch-reject', 'POST', data)
}
// 获取手动发放奖励的明细
export function genericRewardDetail (id) {
  return request('/mallsales/api/generic-reward/' + id, 'GET')
}
// 闪贷申请列表
export function flashBorrowList (data) {
  return request('/mallsales/api/flash-borrow/findAll', 'POST', data)
}
// 闪贷返现详情
export function flashBorrowDetail (id) {
  return request('/mallsales/api/flash-borrow/details/' + id, 'GET')
}
// 闪贷返现审核通过
export function flashBorrowAudit (data) {
  return request('/mallsales/api/flash-borrow/audit', 'POST', data)
}
// 完成闪贷返现
export function flashBorrowComponent (data) {
  return request('/mallsales/api/flash-borrow/complete', 'POST', data)
}
// 导出闪贷返现
export function flashBorrowExport (data) {
  return request('/mallsales/api/flash-borrow/down', 'POST', data)
}
// 查询奖励的业务类型枚举接口
export function getRewardBusinessType () {
  return request('/mallsales/api/reward-business-type/all', 'GET')
}
// 新建奖励类型枚举接口
export function createRewardBusinessType (data) {
  return request('/mallsales/api/reward-business-type/create', 'POST', data)
}
// 新建分/子公司
export function createBranchCompany (data) {
  return request('/mallsales/api/branches', 'POST', data)
}
// 编辑分/子公司
export function updateBranchCompany (data) {
  return request('/mallsales/api/branches', 'PUT', data)
}
// 获取分/子公司详情
export function getBranchCompanyDetail (id) {
  return request('/mallsales/api/branches/' + id, 'GET')
}
// 获取分/子公司列表
export function getBranchCompanyListWechat (data) {
  return request('/mallsales/api/branches/wechat/get-all', 'POST', data)
}
// 获取分/子公司列表
export function getBranchCompanyList (data) {
  return request('/mallsales/api/branches/get-all', 'POST', data)
}
// 删除分/子公司
export function deleteBranchCompany (id) {
  return request('/mallsales/api/branches/' + id, 'DELETE')
}
// 新建医院
export function createHospital (data) {
  return request('/uaa/api/hospitals', 'POST', data)
}
// 编辑医院
export function updateHospital (data) {
  return request('/uaa/api/hospitals', 'PUT', data)
}
// 获取医院详情
export function getHospitalDetail (id) {
  return request('/uaa/api/hospitals/' + id, 'GET')
}
// 获取医院列表
export function getHospitalList (data) {
  return request('/uaa/api/hospitals/get-all', 'POST', data)
}
// 删除医院
export function deleteHospital (id) {
  return request('/uaa/api/hospitals/' + id, 'DELETE')
}
// 新建医生
export function createDoctor (data) {
  return request('/uaa/api/doctors', 'POST', data)
}
// 编辑医生
export function updateDoctor (data) {
  return request('/uaa/api/doctors', 'PUT', data)
}
// 获取医生详情
export function getDoctorDetail (id) {
  return request('/uaa/api/doctors/' + id, 'GET')
}
// 获取医生列表
export function getDoctorList (data) {
  return request('/uaa/api/doctors/get-all', 'POST', data)
}
// 删除医生
export function deleteDoctor (id) {
  return request('/uaa/api/doctors/' + id, 'DELETE')
}
// 成人实验室订单列表
export function getAdultOrderList (data) {
  return request('/adultlab/api/gene/order/export', 'POST', data)
}
// 成人实验室订单列表（过滤掉有待办的订单）
export function AdultexcludeTask (data) {
  return request('/adultlab/api/gene/order/exclude-task', 'POST', data)
}
// 成人实验室订单模糊查询
export function adultOrderFuzzy (data) {
  return request(`/adultlab/api/gene/order/fuzzy-query/`, 'POST', data)
}
// 导出成人实验室订单
export function exportAdultOrders (data) {
  return exportBinary(`adultlab/api/gene/order/export-excel`, 'POST', data)
}
// 批量下载报告
export function downloadAdultReport (data) {
  return request('/adultlab/api/gene/order/export-pdf', 'POST', data)
}
// 成人实验室订单（包括订单详情，订单状态详情，和订单小状态）
export function getAdultOrderDetail (id) {
  return request(`/adultlab/api/order/details/${id}`, 'GET')
}
// 修改成人实验室订单
export function editAdultOrder (data) {
  return request('/adultlab/api/orders/edit', 'POST', data)
}
// 创建成人实验室订单
export function creatAdultOrder (data) {
  return request('/adultlab/api/orders/by-agent', 'POST', data)
}
/**
 * 订单数的统计接口返回异常订单数和代办数
 * oss直传获取签名
 * @param {*} data
 */
export function getSpecialAdultOrderCount () {
  return request('/adultlab/api/order/count', 'GET')
}
/**
 * 成人实验室订单状态更新
 * @param {*} data
 */
export function AdultOrderStatusUpdate (data) {
  return request('/adultlab/api/workflow/order-batch-status-update', 'POST', data)
}
/**
 * 成人实验室订单状态更新文件上传接口
 * @param {*} data
 */
export function AdultuploadTempFile (data) {
  return useFormData(request)('/adultlab/api/workflow/upload-temp-file', 'multipleFILE', data)
}
/**
 * 订单处理列表
 * @param {*} data
 */
export function AdultorderHandleList (data) {
  return request('/adultlab/api/future-order-action-tasks/by-example', 'POST', data)
}
/**
 * 处理代办
 * @param {*} data
 */
export function AdultpendingTasksSubmit (data) {
  return request('/adultlab/api/future-order-action-tasks/submit', 'POST', data)
}
// 批量创建实验室订单
export function creatAdultOrderFlow (data) {
  return request('/adultlab/api/workflow/order/import', 'POST', data)
}
/**
 * 基因实验室订单状态更新(核酸提取批量手动勾选专用接口)
 * @param {*} data
 */
export function AdultOrderStatusUpdateNoFile (data) {
  return request('/adultlab/api/workflow/order-batch-status-update/without-attachment', 'POST', data)
}
// 使用example对象为当前用户查询存储项列表(实验室订单)
export function AdultlabExportHistoryList (data) {
  return request('/adultlab/api/user/oss/items/by-example', 'POST', data)
}
// 根据代理获取产品
export function getAdultProductByAgentId (data) {
  return request('/adultlab/api/agent-products/query', 'POST', data)
}
// 根据手机号获取用户信息(根据userLogin)
export function getUserByMobile (mobile) {
  return request(`/uaa/api/mall-user/by-mobile/${mobile}`, 'GET')
}
// 根据userLogin获取用户信息
export function getUserByLogin (login) {
  return request(`/uaa/api/mall-user/by-login/${login}`, 'GET')
}
// 成人实验室报告生成步骤上传真正的报告
export function AdultuploadReports (data) {
  return request('/adultlab/api/orders/update-reports', 'POST', data)
}
// 成人实验室库存管理
export function adultInventories (data) {
  return request('/adultlab/api/inventories/by-example', 'POST', data)
}
/**
 * 出库扫码获取详细信息
 * @param {*} data
 */
export function AdultStockFindDetailBySampleId (id) {
  let data = {
    example: {
      sampleId: id
    },
    pageable: {
      page: 0,
      size: 9999
    }
  }
  return request('/adultlab/api/inventories/by-example', 'POST', data)
}
/**
 * 入库
 * @param {*} data
 */
export function outbound (data) {
  return request('/adultlab/api/inventories/output', 'POST', data)
}
/**
 * 获取医院／子公司的产品
 * @param {*} data
 */
export function getAgentProducts (data) {
  return request('/adultlab/api/agent-products/query', 'POST', data)
}
/**
 * 上传excel的样本出库
 * @param {*} data
 */
export function outboundByUpload (data) {
  return request('/adultlab/api/inventories/output/upload', 'POST', data)
}
/**
 * 成人出入库模糊查询
 * @param {*} data
 */
export function stockFuzzyQuery (data) {
  return request('/adultlab/api/inventories/fuzzy-query', 'POST', data)
}
/**
 * 获取分子公司业务类型
 * @param {*} data
 */
export function getBrachBusinessType (data) {
  return request('/mallsales/api/branches/business-type', 'POST', data)
}
/**
 *
 * 判断当前用户是否是主公司用户
 */
export function getIsPrimaryUser () {
  return request('/lab/api/orders/is-primary-organization-user', 'GET')
}
// 根据mallueserId获取样本用户信息
export function getUserSamples (data) {
  return request('/mallsales/api/mall-samples/get-by-user-do', 'POST', data)
}
// 根据userLogin查询运营订单
export function getUserContracts (data) {
  return request('/formerop/api/cps/contracts/get-by-user-do', 'POST', data)
}
// 同步用户运营中心的cps合同到本系统
export function getCPSSyn (userLogin) {
  return request('/formerop/api/cps/cps/syn/' + userLogin, 'POST')
}
// C端报告是否对用户隐藏
export function toVisibleReport (labOrderId) {
  return request(`/mallsales/api/mall-samples/get-by-lab-order-id/${labOrderId}`, 'GET')
}
// 订单详情C端报告状态
export function ReportDetail (labOrderId) {
  return request(`/mallsales/api/mall-samples/get-by-lab-order/${labOrderId}`, 'GET')
}
// 用户详情-样本列表页面-屏蔽/解除屏蔽
export function getMallSampleById (id) {
  return request('/mallsales/api/mall-samples/get-by-id/' + id, 'GET')
}
// 用户详情-样本列表页面-删除样本
export function deleteMallSample (id) {
  return request('/mallsales/api/mall-samples/' + id, 'DELETE')
}
// 用户详情-订单列表页面-删除订单
export function deleteMallOrder (id) {
  return request('/mallsales/api/mall-orders/' + id, 'DELETE')
}
// 根据导入之后返回的userListId分页查询无效的用户
export function invalidUserList (data) {
  return request('/mallsales/api/mall-user-import/find/invalid-user', 'POST', data)
}
// 删除已导入的用户列表
export function deleteImportCustomer (userListId) {
  return request('mallsales/api/mall-user-import/delete/' + userListId, 'DELETE')
}
// 导出用户列表
export function exportCustomerList (data) {
  return request('/uaa/api/mall-user/export-to-oss', 'POST', data)
}
// 用户导出历史
export function exportHistoryOfCustomer (data) {
  return request('/uaa/api/user/oss/items/by-example', 'POST', data)
}
// 兑换记录导出历史
export function exportHistoryOfIntegral (data) {
  return request('/points/api/user/oss/items/by-example', 'POST', data)
}
// 用户导入
export function customerUploadTempFile (data) {
  return useFormData(request)('/mallsales/api/mall-user-import/import', 'multipleFILE', data)
}
// 获取用户会员等级信息
export function customerMemberLevelInfo (userLogin) {
  return request('/members/api/member-level-info/by-login/' + userLogin, 'GET')
}
// 获取已导入用户列表
export function importedCustomer (data) {
  return request('/mallsales/api/mall-user-import/find/valid-user', 'POST', data)
}
// 删除实验室订单
export function deleteLabOrder (id) {
  let data = {
    orderId: id
  }
  return request(`/lab/api/future-order-action-tasks/order/delete`, 'GET', data)
}
// 删除成人实验室订单
export function adultDeleteLabOrder (id) {
  let data = {
    orderId: id
  }
  return request(`/adultlab/api/future-order-action-tasks/order/delete`, 'GET', data)
}
// 获取报名列表（活动报名/存储报名）
export function getSignList (data) {
  return request('/mallsales/api/mall-registration-events/query', 'POST', data)
}
// 获取活动的报名记录
export function getSignNotes (data) {
  return request('/mallsales/api/mall-user-registrations', 'POST', data)
}
// 获取报名记录详情
export function signNotesDetail (id) {
  return request('/mallsales/api/mall-user-registrations/' + id, 'GET')
}
// 取消报名
export function cancelSign (id) {
  return request('/mallsales/api/mall-user-registrations/cancel/' + id, 'GET')
}
// 查询活动报名详情
export function getSignDetail (id) {
  return request('/mallsales/api/mall-registration-events/' + id, 'GET')
}
// 报名记录导出
export function exportSign (data) {
  return request('/mallsales/api/down/mall-user-registrations', 'POST', data)
}
// 奖励汇总列表
export function getAllAuditList (data) {
  return request('/mallsales/api/generic-reward/advanced-query', 'POST', data)
}
export function getMedicalRewardList (data) {
  return request('/mallsales/api/generic-reward/doctor-invite-reward', 'POST', data)
}
// 奖励汇总列表导出
export function exportAUditAll (data) {
  return request('/mallsales/api/generic-reward/export', 'POST', data)
}
// 河北医护活动列表导出
export function exportMedicalRewardList (data) {
  return request('/mallsales/api/generic-reward/doctor-invite-reward-export', 'POST', data)
}
// 节假日查询
export function getHolidays (data) {
  return request('/lab/api/holiday/search', 'POST', data)
}
// 节假日创建
export function createHoliday (data) {
  return request('/lab/api/holiday/create', 'POST', data)
}
// 节假日修改
export function editHoliday (data) {
  return request('/lab/api/holiday/edit', 'POST', data)
}
// 单个节假日删除
export function deleteHoliday (id) {
  return request(`/lab/api/holiday/delete/${id}`, 'GET')
}
// 批量节假日删除
export function deleteHolidays (ids) {
  return request(`/lab/api/holiday/delete-by-ids`, 'POST', ids)
}
// 批量节假日获取
export function getHoliday (id) {
  return request(`/lab/api/holiday/by-id/${id}`, 'GET')
}
// 批量节假日导入
export function importHoliday (data) {
  return request(`/lab/api/holiday/import`, 'POST', data)
}
// 成人节假日查询
export function getAdultHolidays (data) {
  return request('/adultlab/api/holiday/search', 'POST', data)
}
// 节假日创建
export function createAdultHoliday (data) {
  return request('/adultlab/api/holiday/create', 'POST', data)
}
// 节假日修改
export function editAdultHoliday (data) {
  return request('/adultlab/api/holiday/edit', 'POST', data)
}
// 单个节假日删除
export function deleteAdultHoliday (id) {
  return request(`/adultlab/api/holiday/delete/${id}`, 'GET')
}
// 批量节假日删除
export function deleteAdultHolidays (ids) {
  return request(`/adultlab/api/holiday/delete-by-ids`, 'POST', ids)
}
// 批量节假日获取
export function getAdultHoliday (id) {
  return request(`/adultlab/api/holiday/by-id/${id}`, 'GET')
}
// 批量节假日导入
export function importAdultHoliday (data) {
  return request(`/adultlab/api/holiday/import`, 'POST', data)
}
// 医生二维码批量导出
export function exportDoctorQrcode (data) {
  return request(`/uaa/api/doctors/down-all`, 'POST', data)
}
// 医生批量导出
export function exportDoctorList (data) {
  return request(`/uaa/api/doctors/export`, 'POST', data)
}
// 获取抽奖券列表
export function getTicketsAct () {
  return request('/mallsales/api/tickets-act', 'GET')
}
export function createPoster (data) {
  return request('/mall/api/posters', 'POST', data)
}
export function updatePoster (data) {
  return request('/mall/api/posters', 'PUT', data)
}
export function getPosterDetail (id) {
  return request(`/mall/api/posters/${id}`, 'GET')
}
export function deletePoster (id) {
  return request(`/mall/api/posters/${id}`, 'DELETE')
}
export function getPosterList (data) {
  return request(`/mall/api/posters/query`, 'POST', data)
}
export function posterOperation (data) {
  return request(`/mall/api/posters/operation`, 'PUT', data)
}
export function searchPoster (data) {
  return request(`/mall/api/_search/posters`, 'POST', data)
}
// 商户余额查询
export function queryMerchantBalance () {
  return request('/mallsales/api/wallet-handler/withdrawals/query-merchant-balance/first', 'GET')
}
// 退款方式获取
export function refundMethod (id) {
  return request('/mallsales/api/bring-new-reward/refund-for-method/' + id, 'GET')
}
// 老带新奖励退款
export function refundBringNewReward (data) {
  return request('/mallsales/api/bring-new-reward/refund-for-batch', 'POST', data)
}
export function getCommodityDetailById (idOrGoodsId) {
  return request(`/mallsales/api/goods/idOrGoodsId/${idOrGoodsId}`, 'GET')
}
// 获取账户余额
export function getUserBalance () {
  return request(`/mallsales/api/balance/currentUserBalance`, 'GET')
}
// 增加账户余额
export function addUserBalance (data) {
  return request(`/mallsales/api/balance/`, 'POST', data)
}
// 手工下单
export function getPlaceOrder (data) {
  return request(`/mallsales/api/mall-orders/manual-place-orders`, 'POST', data)
}
// 异常提现记录回退操作
export function addUserWalletBalance (data) {
  return request('/mallsales/api/withdrawals-log/withdrawlsRollBack', 'POST', data)
}
// 查询改动的咨询师和医生的电话号码是否已经是生命银行用户
export function getHasMallUser (mobile) {
  return request(`uaa/api/users/${mobile}`, 'GET')
}
// 获取生命体验馆列表
export function getLifeExperienceHallsList (data) {
  return request(`uaa/api/user/life-experience-halls/page-by-query`, 'POST', data)
}
export function getLifeExperienceHallsDetail (id) {
  return request(`uaa/api/user/life-experience-halls/${id}`, 'GET')
}
// 新建生命体验馆
export function createLifeExperienceHallsList (data) {
  return request(`uaa/api/user/life-experience-halls`, 'POST', data)
}
// 编辑生命体验馆
export function editLifeExperienceHallsList (data) {
  return request(`uaa/api/user/life-experience-halls`, 'PUT', data)
}
// 删除生命体验馆
export function deleteLifeExperienceHallsList (id) {
  return request(`uaa/api/user/life-experience-halls/${id}`, 'DELETE')
}
// 删除生命体验馆
export function downloadLifeExperienceHallsQrcode (id) {
  return request(`uaa/api/user/life-experience-halls/download/${id}`, 'GET', id)
}
export function getReservationNotifications (data) {
  return request(`/mallsales/api/reservation-notifications?page=${data.page}&size=${data.size}&sort=read`, 'get')
}
export function getReservationNotificationsNoReadCount () {
  return request(`/mallsales/api/reservation-notifications/no-read-count`, 'get')
}
export function setNotificationsIsRead (id) {
  return request(`/mallsales/api/reservation-notifications/read/${id}`, 'get')
}
export function setAllNotificationsIsRead () {
  return request(`/mallsales/api/reservation-notifications/read-all`, 'get')
}
// 获取生命体验馆预约参观信息
export function getLifeExperienceHallsReservation (data) {
  return request(`/mallsales/api/reservations`, 'get', data)
}
export function getLifeExperienceHallsReservationAdvanced (data) {
  return request(`/mallsales/api/reservations/advanced-query`, 'post', data)
}
export function updateLifeExperienceHallsReservation (data) {
  return request(`/mallsales/api/reservations/update`, 'post', data)
}
export function getReservationDate () {
  return request(`/mallsales/api/public/reservation/find-date`, 'post')
}
export function getReservationTime (data) {
  return request(`/mallsales/api/public/reservation/find-time`, 'post', data)
}
export function cancelLifeExperienceHallsReservation (id) {
  return request(`/mallsales/api/reservations/cancel?id=${id}`, 'get')
}
export function createLifeExperienceHallsReservationNotCan (data) {
  return request(`/mallsales/api/reservations/create-not-can`, 'post', data)
}
export function updateReservationNote (data) {
  return request(`/mallsales/api/reservations/update-note`, 'post', data)
}
export function updateReservationStatus (data) {
  return request(`/mallsales/api/reservations/update-status`, 'post', data)
}
// 生命体验馆预约参观信息详情
export function getLifeExperienceHallsReservationDetail (id) {
  return request(`/mallsales/api/reservations/${id}`, 'GET')
}
export function getLifeExperienceHallsReservationTime () {
  return request(`/mallsales/api/reservations/get-time`, 'GET')
}
export function reservationExport (data) {
  return request(`/mallsales/api/reservations/export`, 'post', data)
}
// 更新新闻是否在工具中心展示
export function updateNewsShowTools (data) {
  return request(`mall/api/news/set-tool-center-visible?id=${data.id}&visible=${data.visible}`, 'POST')
}
// 更新新闻是否在活动中心展示
export function updateNewsShowActionCenter (data) {
  return request(`mall/api/news/set-action-center-visible?id=${data.id}&visible=${data.visible}`, 'POST')
}
// 报名模块节假日管理(获取节假日列表)
export function getHolidayOfSign (data) {
  return request('/mallsales/api/holiday/search', 'POST', data)
}
// 报名模块节假日管理（删除节假日）
export function deleteHolidayOfSign (id) {
  return request(`/mallsales/api/holiday/delete/${id}`, 'GET')
}
// 批量删除节假日
export function deleteHolidaysOfSign (ids) {
  return request('/mallsales/api/holiday/delete-by-ids', 'POST', ids)
}
// 创建节假日
export function createHolidayOfSign (data) {
  return request('/mallsales/api/holiday/create', 'POST', data)
}
// 编辑节假日
export function editHolidayOfSign (data) {
  return request('/mallsales/api/holiday/edit', 'POST', data)
}
// 获取节假日详情
export function getHolidayDetail (id) {
  return request(`/mallsales/api/holiday/by-id/${id}`, 'GET')
}
// 节假日excel导入
export function importHolidayOfSign (data) {
  return request('/mallsales/api/holiday/import', 'POST', data)
}
// 获取报名记录和报名详情接口
export function getRegisterNoteDetail (data) {
  return request(`/mallsales/api/public/mall-registration-and-events/by-record-id-or-id`, 'GET', data)
}
// 编辑用户报名接口
export function editUserRegistrations (data) {
  return request('/mallsales/api/user/update-mall-user-registrations/pc', 'POST', data)
}
// 查询传入时间是否是当前时间
export function getDateIsHoliday (data) {
  return request('/mallsales/api/holiday/is-holiday', 'POST', data)
}
// 确认报名
export function confirmRegistration (id) {
  return request(`/mallsales/api/user/activity-registration/confirm/${id}`, 'GET')
}
// 导入医生列表
export function importDoctorList (data) {
  return request(`/uaa/api/doctors/import-from-excel`, 'POST', data)
}
// 获取业务部列表
export function getBusinessDepartment () {
  return request('/mallsales/api/businesses-department/', 'GET')
}
// 事业部增加额度
export function AddBalance (data) {
  return request('/mallsales/api/quotaChangeLog/', 'POST', data)
}
// 查询指定事业部的额度
export function getDepartmentBalance (id) {
  return request(`/mallsales/api/quota/${id}`, 'GET')
}
// 查询所有事业部的总额度
export function getAllDepartmentBalance () {
  return request(`/mallsales/api/quota/total`, 'GET')
}
// 获取账户额度变动记录
export function getBalanceList (data) {
  return request(`/mallsales/api/quotaChangeLog/advanced-query`, 'POST', data)
}
// 获取账户额度变动记录详情
export function getBalanceDetail (id) {
  return request(`/mallsales/api/quotaChangeLog/${id}`, 'GET')
}
// 删除账户额度信息
export function deleteBalanceDetail (id) {
  return request(`/mallsales/api/quotaChangeLog/${id}`, 'DELETE')
}
// 更新账户额度信息
export function updateBalance (data) {
  return request(`/mallsales/api/quotaChangeLog/`, 'PUT', data)
}
// 未提现总金额
export function noWithdrawalsAmount () {
  return request('/mallsales/api/withdrawals-log/no-withdrawals-amount', 'GET')
}
// 积分任务列表
export function getIntegralTaskList (data) {
  return request('/members/api/points-task-manage/query-by-statistic', 'POST', data)
}
// 积分任务详情
export function getIntegralTask (id) {
  return request(`/members/api/points-tasks/admin/${id}`, 'GET')
}
// 获取积分任务的变更记录
export function getEditLogs (data) {
  return request(`/members/api/user/points-task-edit-logs/page-by-query`, 'POST', data)
}
// 编辑积分任务
export function udpateIntegralTask (data) {
  return request(`/members/api/points-tasks/admin`, 'PUT', data)
}
// 禁用积分任务
export function disabledIntegralTask (id) {
  return request(`/members/api/points-tasks/admin/disabled/${id}`, 'GET')
}
// 启用积分任务
export function enabledIntegralTask (id) {
  return request(`/members/api/points-tasks/admin/enabled/${id}`, 'GET')
}
// 获取运营活动的促销活动接口（订单筛选使用）
export function getOperationalPromotion () {
  return request('/mallsales/api/mall-orders/get-promotion-event-id-by-general-action', 'GET')
}
// 获取各个所有事业部额度
export function getEachBusinessDepartmentQuota () {
  return request('/mallsales/api/quota/each-business-department-quota', 'GET')
}
export function editOrderInfo (data) {
  return request('/mallsales/api/mall-orders/edit-order-info', 'POST', data)
}
// 获取积分商品详情
export function getIntegralGoodsDetail (id) {
  return request(`/points/api/goods/${id}`, 'GET')
}
// 保存/修改积分商品接口
export function saveIntegralGoods (data) {
  return request('/points/api/goods/save', 'POST', data)
}
// 获取积分商品运费规则接口
export function getIntegralaCarriagePolicies (data) {
  return request('/points/api/carriage-policies', 'GET', data)
}
// 获取积分商品售后政策接口
export function getIntegralAfterSalesPolicies (data) {
  return request('/points/api/after-sales-policies', 'GET', data)
}
// 查询积分商城隐私政策接口
export function getIntegralPrivacyPolicies (data) {
  return request('/points/api/privacy-policies', 'GET', data)
}
// 积分商品类型获取
export function getIntegralGoodsTypes (data) {
  let { belong } = data
  return request(`/points/api/goods-type/belong/${belong}`, 'GET')
}
// 获取所有积分商品类型
export function getIntergralGoodsTypesOfAll () {
  return request('/points/api/goods-type', 'GET')
}
// 新建积分商场售后政策
export function createIntegralAfterSalesPolicies (data) {
  return request('/points/api/after-sales-policies', 'POST', data)
}
// 新建积分商城运费规则
export function createIntegralCarriagePolicies (data) {
  return request('/points/api/carriage-policies', 'POST', data)
}
// 新建积分商城隐私政策
export function createIntegralPrivacyPolicies (data) {
  return request('/points/api/privacy-policies', 'POST', data)
}
// 积分商品售后政策详情
export function integralAfterSalesPolicieDetail (id) {
  return request(`/points/api/after-sales-policies/${id}`, 'GET')
}
// 编辑积分商品售后政策
export function editIntegralAfterSalesPolicie (data) {
  return request('/points/api/after-sales-policies', 'PUT', data)
}
// 删除积分商品售后政策
export function deleteIntegralAfterSalesPolicie (id) {
  return request(`/points/api/after-sales-policies/${id}`, 'DELETE')
}
// 删除积分商品运费政策
export function deleteIntegralCarriagePolicie (id) {
  return request(`/points/api/carriage-policies/${id}`, 'DELETE')
}
// 删除积分商品隐私政策
export function deletePrivacyPolicies (id) {
  return request(`/points/api/privacy-policies/${id}`, 'DELETE')
}
// 获取积分商品运费规则详情
export function getCarriagePoliciesDetail (id) {
  return request(`/points/api/carriage-policies/${id}`, 'GET')
}
// 获取积分商品隐私条款详情
export function getPrivacyPoliciesDetail (id) {
  return request(`/points/api/privacy-policies/${id}`, 'GET')
}
// 获取积分商品分组接口
export function getIntegralGoodsGroups (data) {
  return request('/points/api/goods-groups/by-example', 'POST', data)
}
// 获取积分商品列表接口
export function getInsterGoodsList (data) {
  return request('/points/api/goods/advanced-query-for-list', 'POST', data)
}
// 查询指定用户的用户积分
export function getUserIntegral (userLogin) {
  return request(`/members/api/points/admin/by-login/${userLogin}`, 'GET')
}
// 按照积分类型查询积分任务
export function getUserIntegralType (data) {
  return request('/members/api/points-tasks/admin/query-by-points-type', 'GET', data)
}
// 查询用户消费积分记录
export function getUserIntegralList (data) {
  return request(`/members/api/points-log/admin/query`, 'POST', data)
}
// 修改积分商品推荐值
export function updateRankingOfIntegral (data) {
  return request('/points/api/goods/update-ranking', 'PUT', data)
}
// 积分商品置顶
export function integralGoodsStick (id) {
  return request(`/points/api/goods/stick/${id}`, 'POST')
}
// 积分商品取消置顶
export function integralGoodsCancelStick (id) {
  return request(`/points/api/goods/cancel-stick/${id}`, 'POST')
}
// 积分商品取消首页推荐
export function integralCancelRecommend (id) {
  return request(`/points/api/goods/cancel-recommend/${id}`, 'POST')
}
// 积分商品推荐到首页
export function integralRecommend (id) {
  return request(`/points/api/goods/recommend/${id}`, 'POST')
}
// 积分商品提交审核
export function integralGoodsApproval (id) {
  return request(`/points/api/goods/apply-for-approval/${id}`, 'POST')
}
// 积分商品审核上架
export function integralGoodsPublish (data) {
  return request('/points/api/goods/publish', 'POST', data)
}
// 积分商品审核驳回
export function integralGoodsReject (id) {
  return request(`/points/api/goods/approval-reject/${id}`, 'POST')
}
// 积分商品下架
export function integralGoodsOffShelves (id) {
  return request(`/points/api/goods/offShelves/${id}`, 'POST')
}
// 获取所有可用会员等级
export function getAllMembers (data) {
  return request(`/members/api/member-levels`, 'GET', data)
}
// 删除积分商品
export function deleteIntegralGoods (id) {
  return request(`/points/api/goods/${id}`, 'DELETE')
}
// 获取积分兑换记录
export function getIntegralExchangeList (data) {
  return request(`/points/api/points-order/get-all`, 'POST', data)
}
// 获取积分兑换订单的进度
export function getIntegralExchangeProgress (orderId) {
  return request(`/points/api/points-order/progress-bar/${orderId}`, 'GET')
}
// 获取指定用户的兑换记录
export function getIntegralExchangeByUserId (data) {
  return request(`/points/api/points-order/get-all`, 'POST', data)
}
// 获取指定用户的兑换记录
export function getIntegralExchangeStatistical (userLogin) {
  return request(`/points/api/points-order/statistical/${userLogin}`, 'GET')
}
// 积分兑换商品发货
export function getIntegralGoodsDelivery (data) {
  return request(`/points/api/points-order/ship`, 'POST', data)
}
// 积分兑换总消费积分
export function getIntegralTotalConsume (data) {
  return request(`/points/api/points-order/total-consume`, 'POST', data)
}
// 积分兑换详情
export function getIntegralDetail (id) {
  return request(`/points/api/points-order/${id}`, 'GET')
}
// 申请退还积分
export function getApplyRefundPoints (data) {
  return request(`/points/api/points-order/apply-refund`, 'POST', data)
}
// 兑换记录导出
export function getIntegralExportExcel (data) {
  return request(`/points/api/points-order/export-excel`, 'POST', data)
}
// 申请退还积分订单导出
export function getRefundPointsExportExcel (data) {
  return request(`/points/api/points-order/refund/export-excel`, 'POST', data)
}
// 申请退还积分订单列表
export function getRefundPointsList (data) {
  return request(`/points/api/points-order/refund/get-all`, 'POST', data)
}
// 同意退还积分申请
export function approvalRefundmentIntegral (data) {
  return request(`/points/api/points-order/approve-refund`, 'POST', data)
}
// 驳回退还积分申请
export function rejectRefundmentIntegral (data) {
  return request(`/points/api/points-order/reject-refund`, 'POST', data)
}
// 新建退还积分原因
export function newIntegralRefundmentReason (data) {
  return request('/points/api/enumeration/' + data.type + '/add', 'POST', data)
}
// 获取退还积分原因
export function getIntegralRefundmentReason (data) {
  return request('/points/api/enumeration/' + data.type + '/', 'GET')
}
// 商品下架
export function offTheShelf (id) {
  return request(`/points/api/goods/offShelves/${id}`, 'POST')
}
// 获取订金结算列表
export function getDepositSettlementList (data) {
  return request('/mallsales/api/deposit-audit/', 'POST', data)
}
// 订金结算列表确认已入库
export function confirmRecord (data) {
  return request('/mallsales/api/deposit-audit/change-order-audit-status', 'PUT', data)
}
// 导出订金结算列表
export function depositSettlementListExport (data) {
  return request('/mallsales/api/deposit-audit/export-for-all-orders', 'POST', data)
}
// 积分明细列表接口
export function membersPointsDetails (data) {
  return request('/members/api/points/details', 'POST', data)
}
// 积分明细积分统计接口
export function membersPointsSum (data) {
  return request('/members/api/points/statistics', 'POST', data)
}
// 积分明细导出接口
export function membersPointsDetailsExport (data) {
  return request('/members/api/points/details/export-excel', 'POST', data)
}
// 积分明细导出历史
export function exportHistoryOfMembers (data) {
  return request('/members/api/user/oss/items/by-example', 'POST', data)
}
// 获取是否产生基本情况报告
export function getBasicReport (data) {
  return request(`/formerop/api/cps/report/check-is-great-report`, 'GET', data)
}
// 获取存储产品进度查询
export function getStorageProgress (data) {
  return request(`/formerop/api/cps/cps-procedure/${data}`, 'GET')
}
// 获取存储产品进度查询(后台,2022-05-23新接口)
export function getCPSStorageProgress (data) {
  return request(`/formerop/api/cps/get-procedure/${data}`, 'GET')
}
// 获取年检报告
export function getAnnualReport (data) {
  return request(`/formerop/api/cps/report/get?cardId=${data.cardId}&proBarcode=${data.proBarcode}`, 'POST')
}
// 获取用户的微信信息
export function getUserWxInfo (userLogin) {
  return request(`/wechat/api/wechat-informations/get-by-login/${userLogin}`, 'GET')
}
// 解绑用户的微信信息
export function unbindWx (id) {
  return request(`/wechat/api/wechat-informations/${id}`, 'DELETE')
}
// 报告预约解读
export function reportInterpreted (id) {
  return request(`/mallsales/api/activity-registration/interpreted/${id}`, 'GET')
}
// 查询订单关联的订单记录
export function getOrderHistory (id) {
  return request(`/mallsales/api/mall-orders/associated/${id}`, 'GET')
}
// 用户详情同步获取订单身份证解绑
export function unbindCps (data) {
  return request(`/mallsales/api/cps/unbind/${data.userId}/${data.identityCard}`, 'PUT')
}
// 将用户信息重新注册到CPS
export function registryCpsUser (userLogin) {
  return request(`/formerop/api/formerop-users/registry/${userLogin}`, 'POST')
}
// 刷新token
export function refreshToken (token) {
  return request(`/auth/refresh`, 'POST', token)
}
export function getSignInvalid (id) {
  return request(`mallsales/api/activity-registration/invalid/${id}`, 'GET')
}
// 获取外部链接列表
export function linkTrackOfAll (data) {
  return request('/mallsales/api/link-track/get-all', 'POST', data)
}
// 新建外部链接
export function creatLink (data) {
  return request('/mallsales/api/link-track', 'POST', data)
}
// 删除链接
export function deleteLink (id) {
  return request(`/mallsales/api/link-track/${id}`, 'DELETE')
}
// 产科问答列表查询
export function getAnswerPageByQuery (data) {
  return request('/qa/api/question-answer/admin/page-by-query', 'POST', data)
}
// 获取一个产科问答详情
export function getQstionAnswerDetail (id) {
  return request(`/qa/api/question-answer/admin/question-detail/${id}`, 'GET')
}
// 医生回答问题/编辑回答
export function answerTheAsk (data) {
  return request('/qa/api/question-answer/admin/answer-edit', 'POST', data)
}
// 屏蔽问答记录
export function answerRecordsBlock (id) {
  return request(`/qa/api/answer-records/blocked/${id}`, 'POST')
}
// 删除问答记录
export function answerRecordsDelete (id) {
  return request(`/qa/api/answer-records/${id}`, 'DELETE')
}
// 关闭问题
export function closeQuestion (id) {
  return request(`/qa/api/main-questions/closed/${id}`, 'POST')
}
// 删除产科问答问题
export function deleteQuestion (id) {
  return request(`/qa/api/main-questions/${id}`)
}
// 名医讲堂
// 新建视频
export function createdVideo (data) {
  return request(`qa/api/lecture-videos`, 'POST', data)
}
// 编辑视频
export function updateVideo (data) {
  return request(`qa/api/lecture-videos`, 'PUT', data)
}
// 获取视频列表
export function getVideoList (data) {
  return request(`qa/api/lecture-videos/page-by-query`, 'POST', data)
}
// 删除视频
export function deteleVideo (id) {
  return request(`qa/api/lecture-videos/${id}`, 'DELETE')
}
// 获取视频详情
export function getVideoDetail (id) {
  return request(`qa/api/lecture-videos/${id}`, 'GET')
}
// 视频操作
export function videoOperation (data) {
  return request(`qa/api/lecture-videos/operation?id=${data.id}&status=${data.status}`, 'PUT', data)
}
// 新建直播
export function createdLive (data) {
  return request(`qa/api/lecture-lives`, 'POST', data)
}
// 编辑直播
export function updateLive (data) {
  return request(`qa/api/lecture-lives`, 'PUT', data)
}
// 获取直播列表
export function getLiveList (data) {
  return request(`qa/api/lecture-lives/page-by-query`, 'POST', data)
}
// 删除直播
export function deteleLive (id) {
  return request(`qa/api/lecture-lives/${id}`, 'DELETE')
}
// 获取直播详情
export function getLiveDetail (id) {
  return request(`qa/api/lecture-lives/${id}`, 'GET')
}
// 获取手动发放积分列表
export function getPointsRewardList (data) {
  return request(`mallsales/api/points-rewards/page-by-query`, 'POST', data)
}
// 创建积分奖励
export function createPointsReward (data) {
  return request(`mallsales/api/points-rewards/create`, 'POST', data)
}
// 获取积分奖励详情
export function getPointsRewardsDetail (id) {
  return request(`mallsales/api/points-rewards/${id}`, 'GET')
}
// 批量审核
export function pointsRewardsBatchAudit (data) {
  return request(`mallsales/api/points-rewards/batch-audit`, 'POST', data)
}
export function pointsRewardsBatchRejected (data) {
  return request(`mallsales/api/points-rewards/batch-rejected`, 'POST', data)
}
export function getCpsInfoByLogin (login) {
  return request(`formerop/api/formerop-users/by-login/${login}`, 'GET')
}
// 手动发放奖励导出
export function manulRewardExport (data) {
  return request(`/mallsales/api/manual-reward/export`, 'POST', data)
}
// 手动发放积分导出
export function pointsRewardExport (data) {
  return request(`/mallsales/api/points-rewards/export`, 'POST', data)
}
// 报告预约解读任务分配
export function reportInterpretAllotTask (data) {
  return request(`/mallsales/api/mall-user-registrations/report-interpret-allot-task`, 'POST', data)
}
// 报告预约解读增加解读详情
export function addReadDetail (data) {
  return request(`/mallsales/api/mall-user-registrations/add-unscramble-detail`, 'POST', data)
}
// 报告预约解读增加附加解读详情
export function addAdditionalReadDetail (data) {
  return request(`/mallsales/api/mall-user-registrations/add-additional-unscramble-detail`, 'POST', data)
}
// 报告预约解读选择复购意向
export function repurchaseIntention (data) {
  return request(`/mallsales/api/mall-user-registrations/set-repurchase-intention`, 'POST', data)
}
// 报告预约解读地区获取
export function getReportAreaList (data) {
  return request(`/mallsales/api/mall-user-registrations/report-unscramble-area-list`, 'GET', data)
}
// 设置预约报告解读状态为电话未接通
export function setStatusPhoneNot (data) {
  return request(`/mallsales/api/mall-user-registrations/set-status-phone-not-get-through/${data}`, 'POST')
}
// 设置预约报告解读状态为其他原因取消
export function setStatusOtherReason (data) {
  return request(`/mallsales/api/mall-user-registrations/set-status-other-reason-cancel/${data}`, 'POST')
}
// 获取解读人员列表
export function getReadPersonnelList () {
  return request(`/mallsales/api/mall-user-registrations/allotUserInfos`, 'GET')
}
// 获取所有解读人员列表
export function getAllReadPersonnelList () {
  return request(`/mallsales/api/mall-user-registrations/all-unscramble-person`, 'GET')
}
// 某条预约报告更改解读师
export function changeAllotUser (data) {
  return request(`/mallsales/api/mall-user-registrations/change-allot-user`, 'POST', data)
}
// 获取解读师详情
export function getReadPeopleDetail (id) {
  return request(`/mallsales/api/mall-user-registrations/allotUserInfo/${id}`, 'GET')
}
// 获取带时间生命体验馆的信息
export function getLifeExperienceHallsTime (data) {
  return request(`/uaa/api/user/life-experience-halls/by/${data}`, 'GET')
}
// 获取分公司下的场馆信息
export function getBranchVenuesInfo (data) {
  return request(`/uaa/api/user/experience-halls/by-activity`, 'POST', data)
}
// 可过滤省市区接口
export function gbcodeAdminDivisions (data) {
  return request('/mallsales/api/public/gbcode-admin-divisions', 'POST', data)
}
// 获取扫码缴费记录列表
export function getScanPaymentList (data) {
  return request('/pay/api/orders/page-by-query', 'POST', data)
}
// 扫码缴费导出接口
export function scanPaymentExport (data) {
  return request('/pay/api/orders/export', 'POST', data)
}
// pay服务的导出历史
export function exportHistoryListPay (data) {
  return request('/pay/api/user/oss/items/by-example', 'POST', data)
}
// 获取投保信息列表
export function getInsureList (data) {
  return request('formerop/api/insure-materials/page-by-query', 'POST', data)
}
// 导出投保信息
export function exportInsureMaterials (data) {
  return request('formerop/api/insure-materials/export', 'POST', data)
}
// 使用example对象为投保信息的导出列表
export function exportHistoryListFormerop (data) {
  return request('/formerop/api/user/oss/items/by-example', 'POST', data)
}
// 获取投保信息的详情
export function getInsureMaterialsDetail (data) {
  return request(`/formerop/api/insure-materials/${data}`, 'GET')
}
// 获取分子公司支付信息
export function getOrganizationMerchant (organizationId) {
  return request(`/pay/api/pay-config/organization-merchant/${organizationId}/config`, 'GET')
}
// 获取跑批数据统计错误信息
export function getCurrentBatch (data) {
  return request('/formerop/api/sync-statistics/getCurrentBatch', 'GET', data)
}
// 跑批异常日志列表接口
export function getgetExceptionList (data) {
  return request('/formerop/api/object-log/getException', 'POST', data)
}
// 导出跑批异常
export function getExceptionExport (data) {
  return request(`/formerop/api/object-log/exportException`, 'POST', data)
}
// 获取咨询师缴费订单
export function consultantPaymentOrder (data) {
  return request(`/mallsales/api/consultant-payment-orders/advanced-query`, 'POST', data)
}
// 导出咨询师缴费订单
export function exportConsultantPaymentOrders (data) {
  return request(`/mallsales/api/consultant-payment-orders/export`, 'POST', data)
}
// 导出咨询师缴费订单
export function exportLifeExperienceHallPaymentOrders (data) {
  return request(`/mallsales/api/consultant-payment-orders/life-experience-hall-export`, 'POST', data)
}
// 导出咨询师缴费订单
export function exportLifeStoragePaymentOrders (data) {
  return request(`/mallsales/api/consultant-payment-orders/storage-export`, 'POST', data)
}
// 扫码支付退款
export function refundPaymentOrder (id) {
  return request(`/mallsales/api/consultant-payment-orders/refund/${id}`, 'GET')
}
// 批量下载咨询师二维码
export function getCounselorCodeZip (data) {
  return request(`/uaa/api/counselor-user-role-informations/down-zip`, 'POST', data)
}
// 导出咨询师
export function exportCounselors (data) {
  return request(`/uaa/api/counselor-user-role-informations/export`, 'POST', data)
}
// 生成咨询师二维码
export function getCounselorQrCode (id) {
  return request(`/uaa/api/counselor-user-role-informations/init-code/${id}`, 'GET')
}
// 编辑投保信息
export function updateInsureInfo (data) {
  return request(`/formerop/api/insure-materials/update`, 'PUT', data)
}
// 根据用户login获取用户的发票信息
export function getInvoiceList (userLogin) {
  return request(`/formerop/api/invoice/get/${userLogin}`, 'GET')
}
// 同步CPS发票
export function getInvoiceSyn (userLogin) {
  return request(`/formerop/api/invoice/syn-invoice/${userLogin}`, 'GET')
}
// 获取待审核数量
export function getWaitAuditCount () {
  return request(`/mallsales/api/reservations/waiting-audit-count`, 'GET')
}
export function updateInvoiceStatus (data) {
  return request(`/mallsales/api/reservations/update-invoice`, 'POST', data)
}
export function financeAuditOfReservation (data) {
  return request(`/mallsales/api/reservations/finance-audit`, 'POST', data)
}
